import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { appConfig } from 'cd-eft/config/AppConfig';
import * as SETAPI from 'cd-eft/services/eftSetApi';

const libraryStore = stores.AppStore.projectsLibraryStore;

export class ActivityLogVM {
  @observable props;
  @observable projectId: string;
  @observable activityLog: any = [];
  @observable pageNumber: number = 1;
  @observable limitPerPage: number = appConfig.hardCodes.activityLogDefaultPaginationRecords;
  constructor(props) {
    this.props = props;
    this.projectId = this.props.projectId;
  }

  @action.bound async getActivityLog(projectId) {
    libraryStore.incrementLoading();
    try {
      const response = await SETAPI.ActivityLogController.getAllActivityLogByProjectUuidUsingGET(this.projectId);
      this.activityLog = response.data;
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      libraryStore.decrementLoading();
    }
  }

  @action.bound setCurrentPage(page) {
    this.pageNumber = page;
  }
}
